export const reviewIssuesValue = {
  '0': 'technical',
  '1': 'unsatisfactory',
  '2': 'translation'
};
